/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeleteAgentPolicyGrantForm,
  DeleteAgentPolicyGrantForm$Outbound,
  DeleteAgentPolicyGrantForm$outboundSchema,
} from "../components/deleteagentpolicygrantform.js";

export type DeleteAgentPolicyGrantSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAgentPolicyGrantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  deleteAgentPolicyGrantForm: DeleteAgentPolicyGrantForm;
};

/** @internal */
export type DeleteAgentPolicyGrantSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAgentPolicyGrantSecurity$outboundSchema: z.ZodMiniType<
  DeleteAgentPolicyGrantSecurity$Outbound,
  DeleteAgentPolicyGrantSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAgentPolicyGrantSecurityToJSON(
  deleteAgentPolicyGrantSecurity: DeleteAgentPolicyGrantSecurity,
): string {
  return JSON.stringify(
    DeleteAgentPolicyGrantSecurity$outboundSchema.parse(
      deleteAgentPolicyGrantSecurity,
    ),
  );
}

/** @internal */
export type DeleteAgentPolicyGrantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DeleteAgentPolicyGrantForm: DeleteAgentPolicyGrantForm$Outbound;
};

/** @internal */
export const DeleteAgentPolicyGrantRequest$outboundSchema: z.ZodMiniType<
  DeleteAgentPolicyGrantRequest$Outbound,
  DeleteAgentPolicyGrantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    deleteAgentPolicyGrantForm: DeleteAgentPolicyGrantForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      deleteAgentPolicyGrantForm: "DeleteAgentPolicyGrantForm",
    });
  }),
);

export function deleteAgentPolicyGrantRequestToJSON(
  deleteAgentPolicyGrantRequest: DeleteAgentPolicyGrantRequest,
): string {
  return JSON.stringify(
    DeleteAgentPolicyGrantRequest$outboundSchema.parse(
      deleteAgentPolicyGrantRequest,
    ),
  );
}
